export const MenuRoutes = [
    {
        title:'Home',
        path:'/'
    }, {
        title:'Issue-Market(ERC1155)',
        path:'/collectionsv2'
    }, 
    {
        title:'Ecosystem',
        path:'/ecosystem',
        elements:[ 
            {title:'Precious (ERC721)',path:'https://precious.nfttv.cc/#/collectionsv2', outLink:true} 
        ]
    }, 
    {
        title:'Studio',
        path:'/studio',
        elements:[ 
            {title:'My Team Wallets',path:'/mywhitelistspagev2'},
            {title:'Create Collection',path:'/createcolletionv2'},
            {title:'Create NFT',path:'/createnftv2'}, 
        ]
    }, 
    {
        title:'About Us',
        path:'https://www.nfttv.cc'
    }
]

// ZenoDigiArt (721) ZenoNexus (1155) ZenoGiving (1155) ZenoMedia (1155)
// ZenoDigiArt (721) ZenoNexus (1155) - (Note, Ticket, Connect) ZenoGiving (1155) - (Charity, Campaign) ZenoMedia (1155)
// ZenoBook (1155)

// zenodigiart (721) zenonexus (1155) zenogiving (1155) zenomedia (1155)
// zenodigiart (721) zenonexus (1155) - (note, ticket, connect) zenogiving (1155) - (charity, campaign) zenomedia (1155)
// zenobook (1155)
